export const deleteTranslation = (record: string) => `Oletko varma, että haluat poistaa ${record}?`;
